import React from "react";
import PropTypes from "prop-types";
import { HelmetProvider } from "react-helmet-async";
import { ApolloProvider } from "@apollo/client";
import { IntlProvider } from "react-intl";
import { BrowserRouter } from "react-router";
import { Global } from "@emotion/react";
import { CLIENT, LOCALE } from "../constants";
import { getBrandRichTextElements } from "constants/brands";
import locales from "locales/data.json";
import Routes from "routes";
import { themes, ThemeContext } from "style";
import globalStyles from "style/global.css";
import Toast from "components/Toast";
import { ModalConfirmationProvider } from "components/Modal";

const RICH_TEXT_ELEMENTS = getBrandRichTextElements();

/**
 * App With Router
 *
 * TODO: Move to root folder
 */
const AppWithRouter = ({ theme, flash }) => (
  <BrowserRouter>
    <ThemeContext.Provider value={theme}>
      <HelmetProvider>
        <ApolloProvider client={CLIENT}>
          <IntlProvider locale={LOCALE} messages={locales[LOCALE]} defaultRichTextElements={RICH_TEXT_ELEMENTS}>
            <ModalConfirmationProvider>
              <Global styles={globalStyles} />
              <Routes flash={flash} />
              <Toast />
            </ModalConfirmationProvider>
          </IntlProvider>
        </ApolloProvider>
      </HelmetProvider>
    </ThemeContext.Provider>
  </BrowserRouter>
);

AppWithRouter.defaultProps = {
  theme: themes.app,
};

AppWithRouter.propTypes = {
  theme: PropTypes.object,
  flash: PropTypes.object,
};

export default AppWithRouter;
